import React from 'react'
import { DimensionValue, StyleSheet, View } from 'react-native'
interface StepProps {
    width: DimensionValue | undefined
    heigth: DimensionValue | undefined
    progress: number
    orientation: 'horizontal' | 'vertical'
    fillColor: string
    backgroundColor: string
    roundStartCorners?: boolean
    roundEndCorners?: boolean
}
export const Step = ({
    width,
    heigth,
    progress,
    orientation,
    fillColor,
    backgroundColor,
    roundStartCorners = false,
    roundEndCorners = false,
}: StepProps) => {
    const cornerRadius = { horizontal: Number(heigth) / 2, vertical: Number(width) / 2 }
    const contentStyle = StyleSheet.create({
        size: {
            width: orientation === 'horizontal' ? `${progress}%` : width,
            height: orientation === 'vertical' ? `${progress}%` : heigth,
        },
        rotate: { transform: orientation === 'horizontal' ? [] : [{ rotate: '180deg' }] },
        verticalProgressCorners: {
            borderTopLeftRadius: roundStartCorners ? cornerRadius.vertical : 0,
            borderTopRightRadius: roundStartCorners ? cornerRadius.vertical : 0,
            borderBottomLeftRadius: roundEndCorners ? cornerRadius.vertical : 0,
            borderBottomRightRadius: roundEndCorners ? cornerRadius.vertical : 0,
        },
        horizontalProgressCorners: {
            borderTopLeftRadius: roundStartCorners ? cornerRadius.horizontal : 0,
            borderBottomLeftRadius: roundStartCorners ? cornerRadius.horizontal : 0,
            borderTopRightRadius: roundEndCorners ? cornerRadius.horizontal : 0,
            borderBottomRightRadius: roundEndCorners ? cornerRadius.horizontal : 0,
        },
    })
    const corners = orientation === 'horizontal' ? contentStyle.horizontalProgressCorners : contentStyle.verticalProgressCorners

    return (
        <View style={[contentStyle.rotate, corners, { width: width, height: heigth, backgroundColor: backgroundColor, overflow: 'hidden' }]}>
            <View style={[contentStyle.size, { backgroundColor: fillColor }]} />
        </View>
    )
}
